module.exports = __webpack_public_path__ + "img/talk-message.830a1bc2.svg";